import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCommand = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 3.79167C1.75 2.66409 2.66409 1.75 3.79167 1.75C4.91925 1.75 5.83333 2.66409 5.83333 3.79167V4.95833H8.16667V3.79167C8.16667 2.66409 9.08075 1.75 10.2083 1.75C11.3359 1.75 12.25 2.66409 12.25 3.79167C12.25 4.91925 11.3359 5.83333 10.2083 5.83333H9.04167V8.16667H10.2083C11.3359 8.16667 12.25 9.08075 12.25 10.2083C12.25 11.3359 11.3359 12.25 10.2083 12.25C9.08075 12.25 8.16667 11.3359 8.16667 10.2083V9.04167H5.83333V10.2083C5.83333 11.3359 4.91925 12.25 3.79167 12.25C2.66409 12.25 1.75 11.3359 1.75 10.2083C1.75 9.08075 2.66409 8.16667 3.79167 8.16667H4.95833V5.83333H3.79167C2.66409 5.83333 1.75 4.91925 1.75 3.79167ZM4.95833 4.95833V3.79167C4.95833 3.14733 4.436 2.625 3.79167 2.625C3.14733 2.625 2.625 3.14733 2.625 3.79167C2.625 4.436 3.14733 4.95833 3.79167 4.95833H4.95833ZM5.83333 5.83333V8.16667H8.16667V5.83333H5.83333ZM4.95833 9.04167H3.79167C3.14733 9.04167 2.625 9.564 2.625 10.2083C2.625 10.8527 3.14733 11.375 3.79167 11.375C4.436 11.375 4.95833 10.8527 4.95833 10.2083V9.04167ZM9.04167 9.04167V10.2083C9.04167 10.8527 9.564 11.375 10.2083 11.375C10.8527 11.375 11.375 10.8527 11.375 10.2083C11.375 9.564 10.8527 9.04167 10.2083 9.04167H9.04167ZM9.04167 4.95833H10.2083C10.8527 4.95833 11.375 4.436 11.375 3.79167C11.375 3.14733 10.8527 2.625 10.2083 2.625C9.564 2.625 9.04167 3.14733 9.04167 3.79167V4.95833Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCommand);
export default ForwardRef;
